import React, {useEffect, useRef, useState} from "react"
import { graphql} from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import Seo from "../components/Seo"
// style
import styled from "styled-components"
import {BackButton, Container, Tokens, Grid, Col, ExternalLink, SlideIn, Browser} from "../components/DesignSystem"


const AboutWrapper = styled.header`
    overflow: hidden;
    min-height: 100vh;
    font-size: var(--fontSizeM);
    h2 {
      font-size: var(--fontSizeXL);
      font-weight: var(--medium);
      margin-top: var(--stackSpacingXL);
    }
    h3 {
      /* font-size: var(--fontSizeL); */
      margin-top: var(--stackSpacingM);
      font-weight: var(--medium);
    }
    h4 {
      margin-top:  var(--stackSpacingM);
      color: #EEE;
      margin-bottom: 0.8rem;
      font-size: var(--fontSizeL);
    }
    h5 {
      font-size: var(--fontSizeS);
      line-height: 1.2;
      margin-top: 0.1rem;
      opacity: 0.6;
    }
    ${Col} {
      @media ${Tokens.md} {
        grid-column: span 12;
      }
    }
`

const AboutSentence = styled.div`
    font-size: var(--fontSizeXXL);
    line-height: 1.4;
    font-weight: var(--medium);
    word-break: none;
    padding-top: var(--stackSpacingL);
`

const ProfilePicture = styled.div`

  box-shadow: 0 6px 40px rgba(0,0,0,0.03);
  main {
    display: grid;
    > div {
      grid-column-start: 1;
      grid-row-start: 1;
      transition: opacity 0.1s ease-in;
    }
  } 
  @media ${Tokens.md} {
    margin-top: var(--stackSpacingM);
  }
  
`


const UnstyledItem = (props) => {
  return (
    <div className={props.className}>
      <h3>{props.title}</h3>
      <h5>{props.subtitle}</h5>
      {
        (props.description) && <p>{props.description}</p>
      }
      
    </div>
  )
};

const Item = styled(UnstyledItem)`
  /* margin-top: 3rem; */
  p {
    margin-top: var(--stackSpacingS);
  }
`

const experience = [
  {
    title: 'Aperia Vietnam',
    subtitle: 'UI/UX Designer, Full-time, Apr 2020 - Current',
    description: 'Worked as a lead designer in a specialized team to create a design system that used in company CRM products.'
  },
  {
    title: 'Samsung Vietnam',
    subtitle: 'UI/UX Designer, Full-time, Jan 2020 - Apr 2020',
    description: 'Joined in a new Samsung design team in Vietnam to build apps for IOT devices.'
  },
  {
    title: 'ECOE Vietnam',
    subtitle: 'UI/UX Designer, Contract, Mar 2019 - Oct 2019',
    description: 'Joined to a design team building a new estate platform in Vietnam Market.'
  },
  {
    title: 'Viivue Web Boutique',
    subtitle: 'Web Designer, Part-time, Nov 2018 - Mar 2019',
    description: 'Worked as a part-time web designer for an agency.'
  },
  {
    title: 'Yeah1 Network',
    subtitle: 'Graphic Designer and Video Editor, Part-time, Dec 2017 - Jul 2018',
    description: 'Worked as a part-time designer and video editor to support marketing materials, landing pages, and videos for Phở Đặc Biệt.'
  }
]

const education = [
  {
    title: 'University of Architecture HCMC (UAH)',
    subtitle: 'BFA in Graphic Design, class of 2016',
    description: 'Focus on Interaction Design, valedictorian of Web/App Specialization'
  },
  {
    title: 'Keyframe Training',
    subtitle: 'Motion Graphic and C4D Animation, class of 2016'
  },
  {
    title: 'Luong The Vinh High School For The Gifted',
    subtitle: 'Specialization in Physics, class of 2013'
  }
]


const AboutPage = ({ data, location }) => {

  const ProfilePictureRef = useRef();
  const [profileOnHover, setProfileOnHover] = useState(false);
  useEffect(() => {
    if(ProfilePictureRef.current) ProfilePictureRef.current.classList.add('animated');
  });
  return (
    <AboutWrapper style={{paddingBottom: '10rem'}}>
     <Seo title="About" />
    <Container>
      <SlideIn distance="-100px" duration={0.6}>
      {location.state && location.state.fromHome && <BackButton fromHome />}
      <Grid>
      <Col span="12">
      <AboutSentence>Hi! I'm Au Duong Tuan - a product designer based in Ho Chi Minh City. I currenly spend my days working on Design System at <ExternalLink href="https://aperia.com" name="Aperia"></ExternalLink>
      </AboutSentence>

      </Col>
      </Grid>
      <Grid style={{justifyContent: 'space-between'}}>
      <Col span="7">
      <h2>Back in the day</h2>
      <p>I have got my hand in Design since 2009, when I learned Photoshop and CSS on my own to make Yahoo! blog themes. Then, I acquired skills in PHP, Wordpress and Javascript to create websites for hobby and friends.</p>
      <p>After high-school graduation in 2013, I went to Design school to boost my creativity. Also, I still have passion for development to create real products.</p>
      <h2>Experience</h2>
      {
        experience.map((item, i) => <Item key={i} {...item} />)
      }
      <h2>Education</h2>
      {
        education.map((item, i) => <Item key={i} {...item} />)
      }
      </Col>
      <Col start="9" span="4">

        {/* <ProfilePicture ref={ProfilePictureRef}>
        <Image fluid={data.tuan1.childImageSharp.fluid} />
          <h4>Vung Tau, 2019</h4>
          </ProfilePicture> */}
        <ProfilePicture  onMouseOver={() => setProfileOnHover(true)} onMouseOut={() => setProfileOnHover(false)}>
        <Browser title={profileOnHover ? 'tuan-haha.jpg' : 'tuan-fancy.jpg'}>
        <div>
        <GatsbyImage
          image={getImage(data.tuan1.childImageSharp)}
          alt={'Tuan Haha'}
         />
         </div>
         <div style={{opacity: profileOnHover ? 1 : 0}}><GatsbyImage image={getImage(data.tuan2.childImageSharp)} alt={'Tuan Fancy'} /></div>
        </Browser>
        </ProfilePicture>

        <h2>Skills</h2>
        <h3>Disciplines</h3>
        <ul>
          <li>User Research</li>
          <li>Motion Graphic</li>
          <li>UX/UI Design</li>
          <li>Design System</li>
          <li>Front-end Development</li>
        </ul>
        <h3>Design & Management</h3>
        {/* <h4>Disciplines</h4> */}
        <ul>
        <li>Adobe Creative Suite</li>
        <li>Sketch, Figma</li>
        <li>Invision, Abstract</li>
        <li>C4D, Blender</li>
        <li>Notion, Jira</li>
        </ul>
        <h3>Tech Stack</h3>
        <ul>
        <li>HTML & CSS, Javascript</li>
        <li>React</li>
        <li>PHP & WordPress</li>
        </ul>
      </Col>
      </Grid>

     
      </SlideIn>
    </Container>
    
    </AboutWrapper>
  );
}
export const pageQuery = graphql`{
  tuan: file(relativePath: {eq: "tuan.jpg"}) {
    childImageSharp {
      gatsbyImageData(width: 434, layout: CONSTRAINED)
    }
  }
  tuan1: file(relativePath: {eq: "tuan_1.jpg"}) {
    childImageSharp {
      gatsbyImageData(width: 600)
    }
  }
  tuan2: file(relativePath: {eq: "tuan_2.jpg"}) {
    childImageSharp {
      gatsbyImageData(width: 600)
    }
  }
}
`
export default AboutPage
